import request from "../utils/request";

const BASE = "/_Admin/SystemSettings";

export interface MaintenanceModeState {
  enabled: boolean;
  message: string | null;
}

export interface MaintenanceModeInput {
  enabled: boolean;
  message: string | null;
}

function normalizeMaintenanceMode(
  data: Partial<MaintenanceModeState> | undefined,
): MaintenanceModeState {
  return {
    enabled: data?.enabled ?? false,
    message: data?.message ?? null,
  };
}

/** 读取完整的维护设置，供管理页和维护页使用。 */
export async function getMaintenanceSettings(): Promise<MaintenanceModeState> {
  const res = await request.get<MaintenanceModeState>(`${BASE}/Maintenance`);
  return normalizeMaintenanceMode(res.data);
}

/**
 * 读取前台维护模式开关状态（所有已登录用户可读）。
 * 开启时非 Admin 用户访问 ASK / MVR 前台页面会展示维护页。
 */
export async function getMaintenanceMode(): Promise<boolean> {
  return (await getMaintenanceSettings()).enabled;
}

/** 同时保存维护开关和维护文案（仅 Admin）。 */
export async function setMaintenanceSettings(
  input: MaintenanceModeInput,
): Promise<MaintenanceModeState> {
  const res = await request.put<MaintenanceModeState>(`${BASE}/Maintenance`, input);
  return normalizeMaintenanceMode(res.data);
}

/**
 * 设置前台维护模式开关（仅 Admin）。返回服务端确认后的开关状态。
 */
export async function setMaintenanceMode(enabled: boolean): Promise<boolean> {
  const current = await getMaintenanceSettings();
  return (await setMaintenanceSettings({ enabled, message: current.message })).enabled;
}
